<template>
	
<com-section :row="true" :section="section" :title="section.inside.title" :completed="completed" :active="active" v-on:next="$emit('next')" v-on:back="$emit('back')">

	<div class="inside-image" :class="{'is-loading': is.imageLoading}">

		<img src="@/assets/aid/health/inside2.gif" v-on:load="onImageLoad" />

		<div class="inside-image-expand" v-on:click="$emit('video')">expand</div>

	</div>

	<div class="text" v-html="section.inside.text"></div>

</com-section>

</template>

<script>

import comSection from './Section'

export default {

	props: ['section', 'completed', 'active'],

	components: {
		'com-section': comSection
	},

	data: function() {

		return {
			is: {
				imageLoading: true
			}
		}

	},

	methods: {

		onImageLoad: function() {

			this.is.imageLoading = false

		}

	}
	
}

</script>

<style scoped>

.inside-image {
	width: 200px;
	margin-right: 16px;
}

.inside-image.is-loading {
	background-position: 50% 50%;
	background-repeat: no-repeat;

}

.inside-image.is-loading img {
	opacity: 0;
}

.is-patient .inside-image-expand {
	background-image: url(~@/assets/icon.expand.patient.svg);
}

.inside-image-expand{
	background-image: url(~@/assets/icon.expand.svg);
	padding-left: 24px;
	line-height: 16px;
	color: #343434;
	letter-spacing: 1px;
	cursor: pointer;
	background-repeat: no-repeat;
	display: inline-block;
	margin: 0px auto;
	text-transform: uppercase;
	font-weight: 600;
	margin-top: 16px;
	font-size: 12px;
}

</style>